export const SVG_ICON_EXTERNAL_DEFAULT_WIDTH = 24
export const SVG_ICON_EXTERNAL_DEFAULT_HEIGHT = 24
export const SVG_ICON_EXTERNAL_SMALL_WIDTH = 18
export const SVG_ICON_EXTERNAL_SMALL_HEIGHT = 18

export default {
  SVG_ICON_EXTERNAL_DEFAULT_WIDTH,
  SVG_ICON_EXTERNAL_DEFAULT_HEIGHT,
  SVG_ICON_EXTERNAL_SMALL_WIDTH,
  SVG_ICON_EXTERNAL_SMALL_HEIGHT
} as const
